// extracted by mini-css-extract-plugin
export var textContainer = "index-module--textContainer--1-KWF";
export var mainText = "index-module--mainText--BRLkR";
export var secondaryText = "index-module--secondaryText--2kICe";